// extracted by mini-css-extract-plugin
module.exports = {"root":"cta-module--root--2z-Ty","title1":"cta-module--title1--21FU1 typography-module--responsiveTitle1--1tLTC"};